export const EXERCISE_FETCH_STARTED = 'EXERCISE_FETCH_STARTED';
export const EXERCISE_FETCH_COMPLETED = 'EXERCISE_FETCH_COMPLETED';

export const TRAINING_MODULE_KIND = 0;
export const EXERCISE_KIND = 1;
export const DISCUSSION_KIND = 2;
